import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getServiceLocationNextBestActions,
  getNextBestActionsForAddress,
  getServiceLocationId,
  putServiceLocationNextBestActionFeedback,
} from '../services/ServiceLocationsService';

export const useServiceLocationsGetServiceLocationNextBestActions = createDCHook(
  'getServiceLocationNextBestActions',
  collapseDataFromCall(getServiceLocationNextBestActions),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useServiceLocationsGetNextBestActionsForAddress = createDCHook(
  'getNextBestActionsForAddress',
  collapseDataFromCall(getNextBestActionsForAddress),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useServiceLocationsGetServiceLocationId = createDCHook(
  'getServiceLocationId',
  collapseDataFromCall(getServiceLocationId),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useServiceLocationsPutServiceLocationNextBestActionFeedback = createMutationHook(
  collapseParams(
    collapseParams(putServiceLocationNextBestActionFeedback, 'requestBody', 'data'),
    'data',
    'actionId',
    'contextId',
    'servingPointId',
    'treatmentVariationId',
    'status',
    'channel',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: ['actionId', 'contextId', 'servingPointId', 'treatmentVariationId', 'status', 'channel'],
      },
    ],
  },
);
